<template>
    <div class="main">
        <div class="prev printNone" @click="prevClick"><van-icon name="arrow-left" class="icon" /></div>
        <div class="next printNone" @click="nextClick"><van-icon name="arrow" class="icon" /></div>
        <div class="main-poster" ref="poster" v-show="domSHow">
            <img class="banner" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2026-01-04/posterBanner${$route.query.currentJobTab}.png`" alt="banner">
            <div class="ranking-list-item">
                <div class="ranking-num">门店</div>
                <div class="ranking-name">客户经理id</div>
                <div class="ranking-order">客户经理</div>
                <div class="ranking-bonus">人数</div>
                <div class="ranking-reward">奖励</div>
            </div>
            <div v-for="(item, index) in list" :key="index + 'listIndex'">
                <div class="ranking-list-item">

                    <div class="ranking-num">{{ item.storeName }}</div>
                    <div class="ranking-name">{{ item.empNo }}</div>
                    <div class="ranking-order">{{ item.employeeName }}</div>
                    <div class="ranking-bonus">{{ item.custNum }}</div>
                    <div class="ranking-reward">{{ item.rewardInfo }}</div>
                </div>
            </div>
        </div>
        <div class="main-poster-active" v-show="!domSHow">
            <img :src="umrImg" />
        </div>

    </div>
</template>

<script>
    import request from '@/utils/request'
    import { debounce, set } from 'lodash';
    import { Toast, Icon } from 'vant'
    import html2canvas from 'html2canvas'
    export default {
        name: 'RankingPoster',
        props: {},
        data() {
            return {
                finished: false,
                loading: false, // 是否正在加载
                list: [],
                page: 1,
                umrImg: '',
                domSHow: true
            }
        },
        mounted() {
            this.getDataList()
            this.$toast('长按保存图片')
        },
        methods: {
            prevClick() {
                if (this.page === 1) {
                    this.$toast('已经是第一页')
                    return
                }
                if (this.domSHow) return
                this.domSHow = true
                this.page -= 1
                this.getDataList()
            },
            nextClick() {
                if (this.finished) {
                    this.$toast('已经是最后一页')
                    return
                }
                //if (this.domSHow) return
                this.domSHow = true
                this.page += 1
                this.getDataList()
            },
            async onFinalAck() {
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                const restore = await this._patchImagesForHtml2Canvas(this.$refs.poster)
                try {
                    const canvas = await html2canvas(this.$refs.poster, {
                        scale: Math.max(window.devicePixelRatio || 1, 2),
                        useCORS: true,
                        allowTaint: false,
                        // imageTimeout: 15000,
                    })
                    this.umrImg = canvas.toDataURL('image/png')
                    Toast.clear();
                    this.domSHow = false
                } finally {
                    restore && restore()
                }
            },
            async _patchImagesForHtml2Canvas(targetEl) {
                try {
                    if (!targetEl || !targetEl.querySelectorAll) return () => { }
                    if (document.fonts && document.fonts.ready) {
                        try { await document.fonts.ready } catch (e) { }
                    }
                    const imgs = Array.from(targetEl.querySelectorAll('img'))
                    if (!imgs.length) return () => { }
                    const patched = []
                    const now = Date.now()
                    imgs.forEach(img => {
                        const rawSrc = img.currentSrc || img.getAttribute('src') || ''
                        if (!rawSrc || rawSrc.startsWith('data:') || rawSrc.startsWith('blob:')) return
                        let abs
                        try {
                            abs = new URL(rawSrc, window.location.href).href
                        } catch (e) {
                            return
                        }
                        if (!this._isCrossOriginUrl(abs)) return
                        patched.push({
                            img,
                            src: img.getAttribute('src'),
                            crossOriginAttr: img.getAttribute('crossorigin')
                        })
                        img.setAttribute('crossorigin', 'anonymous')
                        img.setAttribute('src', this._withCacheBust(abs, now))
                    })
                    await this._waitForImagesLoaded(patched.map(p => p.img), 15000)
                    return () => {
                        patched.forEach(p => {
                            try {
                                if (p.crossOriginAttr == null) p.img.removeAttribute('crossorigin')
                                else p.img.setAttribute('crossorigin', p.crossOriginAttr)
                                if (p.src == null) p.img.removeAttribute('src')
                                else p.img.setAttribute('src', p.src)
                            } catch (e) { }
                        })
                    }
                } catch (e) {
                    return () => { }
                }
            },
            _isCrossOriginUrl(url) {
                try {
                    const u = new URL(url, window.location.href)
                    return u.origin !== window.location.origin
                } catch (e) {
                    return false
                }
            },
            _withCacheBust(url, ts = Date.now()) {
                try {
                    const u = new URL(url, window.location.href)
                    if (!u.searchParams.has('_h2c')) u.searchParams.set('_h2c', String(ts))
                    return u.toString()
                } catch (e) {
                    const joiner = url.includes('?') ? '&' : '?'
                    return `${url}${joiner}_h2c=${ts}`
                }
            },
            _waitForImagesLoaded(imgs, timeoutMs = 15000) {
                const list = (imgs || []).filter(Boolean)
                if (!list.length) return Promise.resolve()
                const waitOne = (img) => new Promise(resolve => {
                    try {
                        if (img.complete && img.naturalWidth > 0) return resolve()
                        const onDone = () => {
                            img.removeEventListener('load', onDone)
                            img.removeEventListener('error', onDone)
                            resolve()
                        }
                        img.addEventListener('load', onDone, { once: true })
                        img.addEventListener('error', onDone, { once: true })
                        setTimeout(onDone, timeoutMs)
                    } catch (e) {
                        resolve()
                    }
                })
                return Promise.allSettled(list.map(waitOne)).then(() => undefined)
            },
            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {

                try {
                    const params = {
                        bu: this.$route.query.currentGroupTab || '',
                        page: this.page,
                        type: this.$route.query.currentJobTab,
                        limit: 70
                    }
                    const { code, msg, data } = await request({
                        url: '/nxCustIncentive/getCustIncentivePage',
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    const list = data && data.rankingList
                    this.list = list
                    this.loading = false;
                    setTimeout(() => {
                        this.onFinalAck()
                    }, 700)
                    this.finished = false;
                    if (list.length < 70) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                }

            }, 500)
        }
    }
</script>

<style lang='less' scoped>
    .main {
        height: 100vh;
        background: #cf1c05;

        .prev {
            position: absolute;
            left: 30px;
            top: 50%;
            transform: translateY(-50%);
            width: 60px;
            height: 60px;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 50%;
            text-align: center;
            line-height: 60px;
            font-size: 40px;
            color: #fff;
            z-index: 999;

        }

        .next {
            position: absolute;
            right: 30px;
            top: 50%;
            transform: translateY(-50%);
            width: 60px;
            height: 60px;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 50%;
            text-align: center;
            line-height: 60px;
            font-size: 40px;
            color: #fff;
            z-index: 999;

        }
    }

    .main-poster {
        overflow-y: scroll;
        background: #cf1c05;
        color: #fff;

        .banner {
            width: 100%;
        }


    }

    .main-poster-active {
        height: 100vh;
        overflow-y: scroll;

        img {
            overflow: auto;
            width: 100%;
            height: auto;
            display: block;
        }
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #dc8282;
        font-size: 24px;

        div {
            text-align: center;
            width: 22%;
        }

        .ranking-bonus {
            width: 12%;
        }


    }
</style>
